export const AdminMenuInfoController = {
    index(): void {},
    origin(): void {},
    updateOrigin(): void {},
    allergen(): void {},
    updateAllergen(): void {},
    nutrition(): void {},
    updateNutrition(): void {},
};
